module.exports = __webpack_public_path__ + "img/Telefon_Verbindung.33994d0a.svg";